import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Linker from '@/components/base/Linker';
import { gettext } from '@/utils/langsBook';
import { makeShardDetailLink } from '@/utils/link';
import clzz from 'classnames';
import { prettyNumber, prettySize, toShard } from '@/utils/string';
var widthTypes = {
    default: [
        220,
        220,
        240,
        200
    ],
    block: [
        275,
        206.47,
        197.18,
        236.41,
        236.41
    ]
};
export var makeShardColumns = function(props) {
    var ref1 = props || {}, _expandable = ref1.expandable, expandable = _expandable === void 0 ? 'default' : _expandable;
    var width = widthTypes[expandable];
    return [
        {
            key: 'ShardIndex',
            title: gettext('Shard ID'),
            className: '!pl-[56px]',
            render: function(row) {
                /*#__PURE__*/ return _jsx(Linker, {
                    href: makeShardDetailLink(toShard(row.ShardIndex, false)),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: clzz({
                            'pl-[9px]': expandable === 'block'
                        }, 'text-primary cursor-pointer'),
                        children: toShard(row.ShardIndex)
                    })
                });
            }
        },
        {
            title: gettext('Size'),
            width: width[1],
            render: function(row) {
                var ref = prettySize(row === null || row === void 0 ? void 0 : row.TotalStateSize) || {}, value = ref.value, unit = ref.unit;
                return(/*#__PURE__*/ _jsxs("p", {
                    children: [
                        value,
                        " ",
                        unit
                    ]
                }));
            }
        },
        {
            title: gettext('Txn Number'),
            render: function(row) {
                /*#__PURE__*/ return _jsx("p", {
                    children: prettyNumber(row.TotalTxn)
                });
            }
        },
        {
            dataIndex: 'Throughput',
            title: gettext('TPS')
        },
        //   dataIndex: 'AddressCount',
        //   title: gettext('Address Number'),
        //   render: value => prettyNumber(value),
        // },
        {
            dataIndex: 'MempoolSize',
            title: gettext('Mempool'),
            render: function(value) {
                return prettyNumber(value);
            }
        }
    ];
};
